import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class DisbursementsAccessoriesService {
  constructor(private http: HttpClientService) {}

  public update(disbursement_accessory): Observable<any> {
    return this.http
      .put(`/api/disbursements_accessories/${disbursement_accessory.id}`, disbursement_accessory)
      .pipe(tap(() => console.log("DisbursementsAccessoriesService.update: Ok.")));
  }
}
